__turbopack_context__.v({
  "bar": "criteria-bar-module__y1ltva__bar",
  "box": "criteria-bar-module__y1ltva__box",
  "chips": "criteria-bar-module__y1ltva__chips",
  "escalate": "criteria-bar-module__y1ltva__escalate",
  "escalateGo": "criteria-bar-module__y1ltva__escalateGo",
  "filterButton": "criteria-bar-module__y1ltva__filterButton",
  "filterCount": "criteria-bar-module__y1ltva__filterCount",
  "hint": "criteria-bar-module__y1ltva__hint",
  "icon": "criteria-bar-module__y1ltva__icon",
  "input": "criteria-bar-module__y1ltva__input",
  "itemDot": "criteria-bar-module__y1ltva__itemDot",
  "itemGo": "criteria-bar-module__y1ltva__itemGo",
  "itemOption": "criteria-bar-module__y1ltva__itemOption",
  "itemTitle": "criteria-bar-module__y1ltva__itemTitle",
  "kbd": "criteria-bar-module__y1ltva__kbd",
  "option": "criteria-bar-module__y1ltva__option",
  "optionAttr": "criteria-bar-module__y1ltva__optionAttr",
  "optionHint": "criteria-bar-module__y1ltva__optionHint",
  "optionIcon": "criteria-bar-module__y1ltva__optionIcon",
  "optionLabel": "criteria-bar-module__y1ltva__optionLabel",
  "pending": "criteria-bar-module__y1ltva__pending",
  "pills": "criteria-bar-module__y1ltva__pills",
  "rows": "criteria-bar-module__y1ltva__rows",
  "suggest": "criteria-bar-module__y1ltva__suggest",
  "token": "criteria-bar-module__y1ltva__token",
  "tokenDefault": "criteria-bar-module__y1ltva__tokenDefault",
});
